/**
 * Where an in-app "upgrade your plan" affordance sends the user.
 *
 * `/dashboard/billing`, NOT `/subscriptions` — and the distinction is load
 * bearing, so read this before changing either.
 *
 * `/dashboard/*` sits behind `AuthGuard` **and `ProfileGuard`**. Every prompt
 * that uses this constant renders inside the dashboard, so whoever sees it has
 * already cleared both guards and billing is reachable.
 *
 * `/subscriptions` is the SIGNUP-flow plan chooser. `PublicGuard` sends a
 * just-registered user there precisely because they have no profile yet and
 * `ProfileGuard` would bounce them straight back out (CAB-514/CAB-517). Those
 * call sites — `PublicGuard`, `SignUpOnboardingPage`, `CheckoutCancelPage` —
 * must keep pointing at `/subscriptions`; repointing them reintroduces a
 * redirect loop.
 *
 * So the rule is: **inside the dashboard → here; pre-profile → /subscriptions.**
 */
export const UPGRADE_ROUTE = '/dashboard/billing';
